module.exports = __webpack_public_path__ + "2837706389db6f816852db35772bca1a.jpg";